export default __webpack_public_path__ + "static/media/Pelvis.850288de.png";